module.exports = __webpack_public_path__ + "img/gaoxiaoyoujianchuangzuo.1018660c.svg";